const mainMenuObject: Array<any> = [
  { label: 'matches', link: '/matches' },
  { label: 'live', link: '/live' },
  { label: 'results', link: '/result' }
];

export default mainMenuObject;
